import React from "react";
import "./TrackBig.scss";
import Point from "./PointBig/PointBig";
import dayjs from "dayjs";

const TrackBig = ({ shipment }) => {

  let showLand = shipment.pick.name
  let showSea = shipment.pod.name
  let showDropoff = shipment.dropoff.name
  let stopsCount = 2
  if (showLand || showSea) stopsCount = 3
  if (showLand && showSea && showDropoff) stopsCount = 4

  const landClassName = stopsCount == 4 ? 'land-small' : 'land'
  const seaClassName = stopsCount == 4 ? 'sea-small' : 'sea'

  function transit(podDate, polDate) {
    polDate = dayjs(polDate, "DD MMM");
    podDate = dayjs(podDate, "DD MMM")
    if (podDate.isBefore(polDate))  // Happens at the end of the year between december and january
      podDate = podDate.add(1, 'y')
    return podDate.diff(polDate, 'day') || ''
  }

  return (
    <div className="TrackBig">
      {showLand && (
        <>
          <Point location={shipment.pick} />
          <div className="route-wrapper"><div className={landClassName}><span>&nbsp;</span></div></div>
        </>
      )}

      <Point location={shipment.pol} />

      {showSea && (
        <>
          <div className="route-wrapper"><div className={seaClassName} data-tt={transit(shipment.pod.date, shipment.pol.date)} ><span>&nbsp;</span></div></div>
          <Point location={shipment.pod} />
        </>
      )}

      {showDropoff && (
        <>
          <div className="route-wrapper"><div className={landClassName}><span>&nbsp;</span></div></div>
          <Point location={shipment.dropoff} />
        </>
      )}
    </div>
  )
}

export default TrackBig;